var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortAlphabetical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7FDC7BC1-7944-4B5B-822F-C0D579D73ECB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.607892 0 0 0 0 0.607803 0 0 0 0 0.607923 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-183.000000, -463.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4149618,23.7126 C5.2627618,23.8946 5.0377618,24 4.8001618,24 C4.5625618,24 4.3375618,23.8946 4.1853618,23.7124 L0.185361801,18.9124 C-0.0974381993,18.5726 -0.0514381993,18.0678 0.287761801,17.785 C0.628361801,17.5022 1.1315618,17.5482 1.4151618,17.8874 L4.0001618,20.99 L4.0001618,0.8 C4.0001618,0.3578 4.3579618,0 4.8001618,0 C5.2423618,0 5.6001618,0.3578 5.6001618,0.8 L5.6001618,20.99 L8.1853618,17.8876 C8.4681618,17.5486 8.9721618,17.5024 9.3127618,17.7852 C9.6517618,18.068 9.6977618,18.5726 9.4149618,18.9126 L5.4149618,23.7126 Z",
    id: "Sort-Alphabet-Ascending-path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2001618,23.2 C19.2001618,22.7578 18.8423618,22.4 18.4001618,22.4 L15.0133618,22.4 L19.0859618,15.6118 C19.2343618,15.365 19.2383618,15.0572 19.0961618,14.8056 C18.9541618,14.5546 18.6883618,14.4 18.4001618,14.4 L13.6001618,14.4 C13.1579618,14.4 12.8001618,14.7578 12.8001618,15.2 C12.8001618,15.6422 13.1579618,16 13.6001618,16 L16.9869618,16 L12.9141618,22.7882 C12.7657618,23.035 12.7617618,23.3428 12.9039618,23.5944 C13.0461618,23.8454 13.3119618,24 13.6001618,24 L18.4001618,24 C18.8423618,24 19.2001618,23.6422 19.2001618,23.2 L19.2001618,23.2 Z",
    id: "Sort-Alphabet-Ascending-path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001618,2.13162821e-14 C17.7649618,2.13162821e-14 19.2001618,1.4352 19.2001618,3.2 L19.2001618,8.8 C19.2001618,9.2422 18.8423618,9.6 18.4001618,9.6 C17.9579618,9.6 17.6001618,9.2422 17.6001618,8.8 L17.6001618,6.4 L14.4001618,6.4 L14.4001618,8.8 C14.4001618,9.2422 14.0423618,9.6 13.6001618,9.6 C13.1579618,9.6 12.8001618,9.2422 12.8001618,8.8 L12.8001618,3.2 C12.8001618,1.4352 14.2353618,2.13162821e-14 16.0001618,2.13162821e-14 Z M16.0001618,1.6 C15.1181618,1.6 14.4001618,2.318 14.4001618,3.2 L14.4001618,4.8 L17.6001618,4.8 L17.6001618,3.2 C17.6001618,2.318 16.8821618,1.6 16.0001618,1.6 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortAlphabetical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sortAlphabetical.399dde067558abb491c93b4e14d7c8ed.svg";